import React, { useState, useEffect } from 'react';
import { Popover, Menu, Form, Input, Button, message, Modal } from 'antd';
import { useHistory } from 'react-router';
import hot from '../../assets/images/hot.png';
import langlayout from '../../assets/images/langlayout.png';
import logo from '../../assets/images/logo.png';
import { DownOutlined, PieChartOutlined } from '@ant-design/icons';
import './index.css';
import api from '../../api';
import { Redirect } from 'react-router';
import { useDataState } from '../../hooks';
import { getNumberDisplayWithCommaNFloating } from '../../utils/string';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

function getItem(label, key, icon, path, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
    path,
  };
}

function getPath(key) {
  const list = ['/step', '/handicap', '/bill', '/deposithistory'];
  return list[key];
}

const items = [
  getItem('บอลสเต็ป', '0', null, '/step'),
  getItem('บอลเต็ง', '1', null, '/handicap'),
  getItem('ประวัติการเล่น', '2', null, '/bill'),
  getItem('ฝาก/ถอน', '3', null, '/deposit'),
];

function Layout({ children }) {
  const username = localStorage.getItem('username');
  const userData = useDataState();
  const [selectedKey, setSelectedKey] = useState(0);
  const [externalBalance, setExternalBalance] = useState(0);

  const [loading, setLoading] = useState();
  const location = useLocation();

  const currentPath = location.pathname;

  useEffect(() => {
    const promise = api.user.getUserDetail(username);
    userData.load(Promise.resolve(promise).then((value) => value));
  }, [loading]);

  // ดึงข้อมูล balance จาก external API
  useEffect(() => {
    const fetchExternalBalance = async () => {
      if (username) {
        try {
          const response = await api.user.getExternalBalance(username, 'SP369');
          console.log('External Balance Response:', response);
          if (response.data.success) {
            setExternalBalance(response.data.Balance);
          }
        } catch (error) {
          console.error('Error fetching external balance:', error);
        }
      }
    };

    fetchExternalBalance();
    // Refresh balance every 30 seconds
    const interval = setInterval(fetchExternalBalance, 30000);
    return () => clearInterval(interval);
  }, [username, loading]);

  const onClick = (e) => {
    setLoading(false);
    setSelectedKey(e.key);
    history.push(getPath(e.key));
    setLoading(true);
  };

  const goToPage = (page) => {
    history.push(page);
  };

  const user = userData?.data?.data;

  const history = useHistory();

  const onLogout = () => {
    localStorage.clear();
    history.push('/');
  };

  return (
    <>
      <meta name="viewport" content="width=device-width, initial-scale=0.4, user-scalable=yes" />
      <div className='container' style={{ width: 'auto' }}>
        <body>
          <header className='topbar'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <img style={{ width: '226px' }} src={logo}></img>
                <div style={{ display: 'flex' }}>
                  <button className='menu-top-btn' style={{ color: currentPath === '/step' ? '#FC0' : '' }} onClick={() => { goToPage('/step') }}>บอลสเต็ป</button>
                  <button className='menu-top-btn' style={{ color: currentPath === '/handicap' ? '#FC0' : '' }} onClick={() => { goToPage('/handicap') }}>บอลเต็ง</button>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginRight: '5px' }}>
                <div className='text' style={{ color: '#fff', alignItems: 'center' }}>
                  {`${moment().format('DD-MM-YYYY LT')} (GMT+7:00)`}
                </div>
                <img src={langlayout} height={'20px'} />
                <div>
                  <div className='user-box'>
                    <div style={{ textAlign: 'center' }}>ยินดีต้อนรับ: <span style={{ fontWeight: 'bold' }}>{username}</span></div>
                    <div style={{ textAlign: 'center' }}>
                      เครดิต:{' '}
                      <span style={{ fontWeight: 'bold' }}>{getNumberDisplayWithCommaNFloating(externalBalance || 0)}</span>
                    </div>
                  </div>
                  <div style={{
                    color: '#fff',
                    backgroundColor: '#203061',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '5px',
                    alignItems: 'center'
                  }}>
                    <div style={{ fontSize: '13px', fontFamily: 'Arial' }}>การตั้งค่า </div>

                    <div>|</div>
                    <div style={{ fontSize: '13px', fontFamily: 'Arial' }} onClick={onLogout}>ออกจากระบบ</div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              display: 'flex',
              background: 'linear-gradient(180deg, #e2eafc 0 %, #bed0f1 100 %)',
              alignItems: 'center',
              paddingLeft: '20px',
              gap: '10px',
              paddingTop: '7px',
              paddingBottom: '7px',
              border: '2px solid #bac1d7'
            }}>
              <div className='menu-bottom' onClick={() => { goToPage('/bill') }}
                style={{ color: currentPath === '/bill' ? '#FC0' : '#000', }}>ประวัติการเล่น</div>
            </div>
          </header>
          <div className='mobile-page-content'>{children}</div>
        </body>
      </div>
    </>
  );
}

export default Layout;
